import { SidePanel } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';
import { CardTransactionDetails } from 'modules/cards/components/CardTransactionDetailsPanel/CardTransactionDetails';

import { SidePanelTitle } from './SidePanelTitle';

type Props = {
  companyId: string;
  onClose: () => void;
  onGoBack?: () => void;
  transactionId: string;
  title?: string;
};

export const CardTransactionDetailsPanel = ({
  companyId,
  onClose,
  onGoBack,
  transactionId,
  title,
}: Props) => {
  const { t } = useTranslation('global');
  const fallbackTitle = t('cards.transactions.details');
  const titleId = 'card-transaction-details';

  return (
    <>
      <SidePanel
        className="CardTransactionDetailsPanel"
        onClose={onClose}
        title={
          <SidePanelTitle
            onClose={onGoBack}
            title={title ?? fallbackTitle}
            titleId={titleId}
          />
        }
      >
        <CardTransactionDetails
          transactionId={transactionId}
          companyId={companyId}
        />
      </SidePanel>
    </>
  );
};
